export const mapboxToken =
  "pk.eyJ1Ijoib2xpdmVyd2FuZ3JlZGNpcmNsZSIsImEiOiJjanN2MjYzMjYwMmlpNDNsdzBlazNlNWt3In0.I7ncgajIiPEWtfvuI0QZ9g";
